import { ref, watch, onMounted } from 'vue';
import { useAppStore } from '@/stores/app.store';
import useToast from '@/composables/useToast';
import useTranslations from '@/composables/useTranslations';

const DELEGATION_COOKIE = 'CwxReturnedToOwnAccount';
const LANGUAGE_MISMATCH_COOKIE = 'CwxDeputyDifferentLanguagesDetected';

export default function useDelegationToast(): void {
  const appStore = useAppStore();
  const { success, warning } = useToast();
  const { translate: t } = useTranslations();

  const shouldShowBackToOwnAccountToast = ref(false);
  const shouldShowLanguageMismatchToast = ref(false);
  const hasShownBackToOwnAccountToast = ref(false);
  const hasShownLanguageMismatchToast = ref(false);

  const showBackToOwnAccountToast = () => {
    success(t('Delegations.BackInYourAccount'), {
      closable: true,
      draggable: false,
      autoClose: 2500,
      position: 'top-center',
      animation: 'bounce',
    });
  };

  const showLanguageMismatchToast = () => {
    warning(t('Delegations.SetDisplayLanguageTitle'), {
      closable: true,
      draggable: false,
      autoClose: false,
      position: 'top-center',
      animation: 'bounce',
      description: t('Delegations.SetDisplayLanguageDescription')
    });
  };

  onMounted(() => {
    shouldShowBackToOwnAccountToast.value = document.cookie.includes(DELEGATION_COOKIE);
    shouldShowLanguageMismatchToast.value = document.cookie.includes(LANGUAGE_MISMATCH_COOKIE);
  });

  watch(
    () => appStore.isTranslationsFetched,
    (isFetched) => {
      if (
        isFetched &&
        shouldShowBackToOwnAccountToast.value &&
        !hasShownBackToOwnAccountToast.value &&
        document.cookie.includes(DELEGATION_COOKIE)
      ) {
        showBackToOwnAccountToast();
        hasShownBackToOwnAccountToast.value = true;
        document.cookie = `${DELEGATION_COOKIE}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;`;
      }

      if (
          isFetched &&
          shouldShowLanguageMismatchToast.value &&
          !hasShownLanguageMismatchToast.value &&
          document.cookie.includes(LANGUAGE_MISMATCH_COOKIE)
      ) {
        showLanguageMismatchToast();
        hasShownLanguageMismatchToast.value = true;
        document.cookie = `${LANGUAGE_MISMATCH_COOKIE}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;`;
      }
    },
    { immediate: true },
  );
}
